import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {ConfService} from '../../conf.service';
import {KongService} from '../../kong.service';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {AttributeDescriptionComponent} from '../../crudapi/crudapi.component';
import {NewMockResponseEntryInputComponent, ReplaceMockDataConfirmationComponent} from '../headers/headers.component';

@Component({
  selector: 'app-mock-response',
  templateUrl: './mock-response.component.html',
  styleUrls: ['./mock-response.component.scss']
})
export class MockResponseComponent implements OnInit {

  accept = false;
  flagValue = true;
  @Input() tempJSON: any;
  @Input() type: any;
  @Input() requestBodySelected: any;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  @ViewChild('aceEditor2') aceEditorXML;
  @ViewChild('aceEditor3') aceEditorHTML;
  options1 = new JsonEditorOptions();
  flag: any;
  httpUrl: string;
  error = false;

  activeTabIndex: any;

  headersData = [];
  formData = [];

  errorMessage: any;
  tableLabelName = 'Table Name';
  entityAndVersion: any;
  datatypes: any;
  @Input() httpOperation: any;
  selectedDatatypeFilter = 'mongodb';
  dataTypeFilter: any;
  databases: any;
  apiByDefinition: any;

  sampleDataType: string;

  rawTypes = [
    {displayName: 'TEXT', value: 'text/plain'},
    {displayName: 'JSON', value: 'application/json'},
    {displayName: 'XML', value: 'application/xml'},
    {displayName: 'HTML', value: 'text/html'}
  ];

  @Input() mockResponses: any;
  @Input() dialogDisplay = false;
  selectDatabase: string;
  constructor(private _service: ConnecttocrudService, private confPost: ConfService, private kongService: KongService,
              private location: Location,
              private route: ActivatedRoute, public platform: LeftpanelComponent,
              public snackBar: MatSnackBar, private router: Router, private Urlroute: ActivatedRoute, public dialog: MatDialog) {
    this.options1.mode = 'code';
    this.options1.modes = ['code', 'text', 'tree', 'view'];
    this.options1.schema = '';
    this.options1.statusBar = false;
    this.options1.onChange = () => console.log(/* this.editor.get()*/);
  }

  async ngOnInit() {
    // console.log(this.mockResponses);
    // if (this.mockResponse.responseAttributes) {
    //   this.apiByDefinition = this.mockResponse.responseAttributes;
    // } else {
    //   this.apiByDefinition = [{
    //     'customType': false,
    //     'apiAccessPolicy': 'None',
    //     'attributeName': null,
    //     'type': null,
    //     'array': false,
    //     'size': null,
    //     'precision': null,
    //     'autoIncrement': false,
    //     'defaultValue': null,
    //     'attributeType': 'None',
    //     'dataStoragePolicy': 'None',
    //     'description': null,
    //     'displayName': null,
    //     'displayPolicy': 'None',
    //     'required': false,
    //     'subType': []
    //
    //   }];
    // }

    // await this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
    //     this.databases = data;
    // });
    if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
      this.datatypes = this.platform.datatypes;
    } else {
      await this.platform.getDataTypesForPartnerAccount();
      this.datatypes = this.platform.datatypes;
    }


    if (this.mockResponses) {
      for (const resp of this.mockResponses) {
        if (!resp.headers) {
          resp.headers = [];
        }
      }
      }


    // this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
    //   this.databases = data;
    // });
    if (this.platform.databases !== null && this.platform.databases !== undefined) {
      this.databases = this.platform.databases;
    } else {
      await this.platform.getDatabasesForPartnerAccount();
      this.databases = this.platform.databases;
    }
    // this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
    //     if (response.status === 200) {
    //         this.entityAndVersion = response.body['entityNameAndVersion'];
    //     }
    // });
    if (this.platform.entityAndVersion !== null && this.platform.entityAndVersion !== undefined) {
      this.entityAndVersion = this.platform.entityAndVersion;
    } else {
      await this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
            if (response.status === 200) {
              this.entityAndVersion = response.body['entityNameAndVersion'];
              this.platform.entityAndVersion = this.entityAndVersion;
            }
          },
          error => {
            this.platform.handleErrorGracefully(error, 'Error while getting entity name and version for partner account. Please try after sometime.');
          });
    }
    this.filterDataTypes(this.selectedDatatypeFilter);
  }
  openAttributeDescriptionDialog(definition) {
    const data = {
      'displayName': definition.displayName,
      'description': definition.description,
      'dataStoragePolicy': definition.dataStoragePolicy,
      'apiAccessPolicy': definition.apiAccessPolicy,
      'displayPolicy': definition.displayPolicy
    };
    const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      this.accept = result;
      definition.displayName = data.displayName;
      definition.description = data.description;
      definition.dataStoragePolicy = data.dataStoragePolicy;
      definition.apiAccessPolicy = data.apiAccessPolicy;
      definition.displayPolicy = data.displayPolicy;
    });
  }
  removeAttribute(data, index) {
    if (confirm('Are you sure you want to remove this attribute?')) {
      data.splice(index, 1);
    }
  }
  setPrimaryFlag(i, type) {
    if (type === 'Primary' && this.flagValue) {
      this.flag = i;
      this.flagValue = false;
    } else if (i === this.flag && !this.flagValue && type !== 'Primary') {
      this.flag = null;
      this.flagValue = true;
    }
  }
  omit_special_char(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)

    return((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57));
  }
  checkNumber(event) {
    let k;
    k = event.charCode;
    return((k >= 48 && k <= 57));
  }
  getRegion(val) {
    return this.platform.getRegion(val);
  }
  getDatabaseTypeForDatabaseName(val) {
    if (this.databases && this.databases !== null && this.databases !== undefined) {
      this.databases.filter(items => {
        if (items.database_name === val) {
          this.selectedDatatypeFilter = items.database_type;
        }
      });
    }
  }
  filterDataTypes(val) {

    // this.getDatabaseTypeForDatabaseName(val);
    this.dataTypeFilter = [];
    if (this.datatypes && this.datatypes !== null && this.datatypes !== undefined) {
      this.datatypes.filter(items => {
        if (items.database_type === this.selectedDatatypeFilter) {
          this.dataTypeFilter.push(items);
        }
      });
    }
    if (this.selectedDatatypeFilter === 'mongodb') {
      this.tableLabelName = 'Collection Name';
    } else {
      this.tableLabelName = 'Table Name';
    }
  }
  typeCheck(definition) {

    const entityAndVersionCheckString = definition.type,
        substring = '_';
    if (entityAndVersionCheckString.includes(substring)) {
      definition.customType = true;
      definition.attributeType = 'DBRef';
    } else {
      definition.customType = false;
      definition.attributeType = 'None';
    }

    if (this.selectDatabase === 'default' || this.selectDatabase === 'mongo') {
      if (definition.type === 'Array' || definition.type === 'Object') {
        this.addAttributeField(definition.subType, this.selectDatabase);
      } else {
        this.removeAttributeField(definition.subType);
      }
    } else {
      if (definition.type === 'Array' || definition.type === 'Object') {
        this.addAttributeField(definition.subType, this.selectDatabase);
      } else {
        this.removeAttributeField(definition.subType);
      }
    }
  }
  removeAttributeField(data) {
    for (var i = 0; i < data.length; i++) {
      data.splice(i, 1);
    }
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  addAttributeField(data, database) {

    if (database === 'mongodb' || database === 'default') {
      const newField = {
        'customType': false,
        'apiAccessPolicy': 'None',
        'attributeName': null,
        'type': null,
        'array': false,
        'size': null,
        'precision': null,
        'autoIncrement': false,
        'defaultValue': null,
        'attributeType': 'None',
        'dataStoragePolicy': 'None',
        'description': null,
        'displayName': null,
        'displayPolicy': null,
        'required': false,
        'subType': []
      };
      data.push(newField);
    } else {
      const newField = {
        'customType': false,
        'apiAccessPolicy': 'None',
        'attributeName': null,
        'type': null,
        'size': null,
        'precision': null,
        'autoIncrement': false,
        'defaultValue': null,
        'attributeType': 'None',
        'dataStoragePolicy': 'None',
        'description': null,
        'displayName': null,
        'displayPolicy': null,
        'required': false,
        'subType': []
      };
      data.push(newField);
    }
  }
  getRequestBody() {
    // if (this.headersData.hasOwnProperty('Content-Type')){
    //     const index = this.headersData.indexOf('Content-Type', 0);
    //     if (index > -1) {
    //         this.headersData.splice(index, 1);
    //     }
    // }
    if (this.requestBodySelected === 'raw') {
      const requestbody = {
        'value': this.getRequestBodyValue(this.requestBodySelected),
        'key' : 'payload',
        'description' : 'Document in JSON format',
        'annotation' : 'RequestBody'
      };
      return requestbody;
    } else if (this.requestBodySelected === 'form-data') {
      const requestbody = {
        'value': this.formData,
        'key' : 'payload',
        'description' : 'Document in JSON format',
        'annotation' : 'RequestBody'
      };
      return requestbody;
    } else if (this.requestBodySelected === 'x-www-form-urlencoded'){
      const requestbody = {
        'value': this.formData,
        'key' : 'payload',
        'description' : 'Document in JSON format',
        'annotation' : 'RequestBody'
      };
      return requestbody;
    } else if (this.requestBodySelected === 'none'){
      const requestbody = {
        'value': '',
        'key' : 'payload',
        'description' : 'Document in JSON format',
        'annotation' : 'RequestBody'
      };
      return requestbody;
    }

  }
  getRequestBodyValue(val) {
    switch (val) {
      case 'raw':
        // return JSON.stringify(this.editor.get());
        return this.editor.get();
      case 'binary':
      case 'none':
      default:
    }
  }

  addMockResponse() {

    const dialogRef = this.dialog.open(NewMockResponseEntryInputComponent, {
      width: '40%',
      data: {statusCode: null}
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.addOrUpdateMockResponse({
          statusCode: parseInt(result.statusCode),
          methodType: this.httpOperation,
          headers: [],
          message: null,
          description: null,
          sampleData: null,
          responseAttributes: [],
        }, true);

      }
    });
  }

  removeMockResponse(index) {
    this.mockResponses.splice(index, 1);
    this.activeTabIndex = this.mockResponses.length - 1;
  }

  async addOrUpdateMockResponse(data, confirmationReq) {
    const index = this.mockResponses.findIndex(value => value['statusCode'] === data['statusCode']);

    if (index === -1) {
      this.mockResponses.push(data);
      this.activeTabIndex = this.mockResponses.length - 1;
    } else {
      let updateData = false;
      if (confirmationReq) {
        const dialogRef = this.dialog.open(ReplaceMockDataConfirmationComponent, {
          width: '40%',
          height: 'auto',
          data: {statusCode: data['statusCode']}
        });
        updateData = await dialogRef.afterClosed().toPromise();
      } else {
        updateData = true;
      }

      if (updateData) {
        this.mockResponses.splice(index, 1, data);
        this.activeTabIndex = this.mockResponses.length - 1;
      }
    }
  }

  rawTypeChange(event, headersData) {
    this.attachContentType(headersData, event.value);
  }

  attachContentType(headersData, type) {
    let contentTypeExists: boolean;
    headersData = headersData ? headersData : [];
    for (const header of headersData) {
      if (header) {
        if (header['name'] === 'Content-Type') {
          header['value'] = type;
          contentTypeExists = true;
        }
      }
    }
    if (contentTypeExists !== true) {
      headersData.push({'name': 'Content-Type', 'value': type});
    }
  }

  getContentType(headersData) {
    let contentTypeExists = false;
    for (const header of headersData) {
      if (header) {
        if (header['name'] === 'Content-Type') {
          contentTypeExists = true;
          if (header['value'] === 'application/json' || header['value'] === 'application/xml' || header['value'] === 'text/html' || header['value'] === 'text/plain') {
            return header['value'];
          } else {
            return 'text/plain';
          }
        }
      }
    }
    if (!contentTypeExists) {
      headersData.push({'name': 'Content-Type', 'value': 'text/plain'});
    }
    return 'text/plain';
  }

  validateAndGetData(type, data) {
    if (type === 'JSON') {
      if (this.editor.isValidJson()) {
        data['sampleData'] = this.editor.get();
      } else {
        data['sampleData'] = this.editor.get();
      }
    } else if (type === 'XML') {
      let isValidContent = true;
      const annotations = this.aceEditorXML.getEditor().getSession().getAnnotations();
      annotations.forEach((annotation) => {
        if (annotation && annotation !== null && annotation !== undefined) {
          if (annotation.type === 'error') {
            isValidContent = false;
          }
        }
      });
      if (isValidContent) {
        const editorData = this.aceEditorXML.getEditor().getSession().getValue();
        data = editorData.replace(/\n/g, '');
      } else {
        this.platform.handleErrorGracefully(null, 'Please check the request body syntax.');
      }
    } else if (type === 'HTML') {
      let isValidContent = true;
      const annotations = this.aceEditorHTML.getEditor().getSession().getAnnotations();
      annotations.forEach((annotation) => {
        if (annotation && annotation !== null && annotation !== undefined) {
          if (annotation.type === 'error') {
            isValidContent = false;
          }
        }
      });
      if (isValidContent) {
        const editorData = this.aceEditorHTML.getEditor().getSession().getValue();
        data = editorData.replace(/\n/g, '');
      } else {
        this.platform.handleErrorGracefully(null, 'Please check the request body syntax.');
      }
    }
  }
}


@Component({
  selector: 'json-editor-2',
  templateUrl: 'dynamic-json-editor.html'
})
export class DynamicJSONSampleDataComponent {

  @Input() options: any;
  @Input() data: any;

  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;

  constructor(public platform: LeftpanelComponent) {
  }

  validateAndGetData(data) {
    if (this.editor.isValidJson()) {
      data['sampleData'] = this.editor.get();
    } else {
      data['sampleData'] = this.editor.get();
    }
  }

};
